// import "./bootstrap";
import React from "react";

import ReactDOM from "react-dom";

import "./index.css";
import App from "./app.js";

ReactDOM.render(<App/>, document.getElementById('root'));
